import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import LeftMenu from "../../components/LeftMenu";
import HelmetComponent from "../../utils/HelmetHelper";
import { requireUserLogin, requireUserVerify } from "../../routes/Auth";
import requireUsernameChange from "../../routes/Auth/HOCs/requireUsernameChange";
import { useDispatch, useSelector } from "react-redux";
import { deleteCart, getMyCarts, selectCarts } from "../../routes/Cart/cart.ducks";
import PaginationFinance from "./PaginationFinance";
import { PageRoute, ShoppingCartFormat } from "../../models";
import { TAB_PARAM, TAB_INVOICES, TAB_TO_FORMAT } from "./constants/constants";

function FinancePage(props: any) {
  const {
    user,
    location,
    match: { path },
    showHeaderLogoAndSearchBarHandler
  } = props;

  const history = useHistory();
  const dispatch = useDispatch();
  const carts = useSelector(selectCarts);

  const params = new URLSearchParams(location.search);
  const activeTab = params.get(TAB_PARAM) || TAB_INVOICES;

  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    showHeaderLogoAndSearchBarHandler;
    loadCarts({
      shoppingCartFormat: TAB_TO_FORMAT[activeTab] || ShoppingCartFormat.invoices
    });
  }, [user, activeTab]);

  const loadCarts = useCallback(
    (params?: {}) => {
      setIsLoading(true);
      dispatch(
        getMyCarts(
          params,
          (success: boolean) => {
            setIsLoading(false);
          }
        )
      );
    },
    [user]
  );

  const handlePageChange = (nextPage: number) => {
    loadCarts({
      page: nextPage,
      shoppingCartFormat: TAB_TO_FORMAT[activeTab] || ShoppingCartFormat.invoices
    });
  };

  const handleTabChange = (key: string) => {
    const newParams = new URLSearchParams();
    newParams.set(TAB_PARAM, key);
    const search = newParams.toString();
    history.push({
      pathname: PageRoute.finance,
      search: search ? `?${search}` : "",
    });
  };

  const handleDeleteCart = (cartId: string) => {
    dispatch(deleteCart(cartId, (success: boolean) => {
      if (success) {
        loadCarts({
          page: carts.page,
          shoppingCartFormat: TAB_TO_FORMAT[activeTab] || ShoppingCartFormat.invoices
        });
      }
    }));
  }

  return (
    <LeftMenu activeKey={path}>
      <HelmetComponent title={`${"Financije"} | ${"INDEX OGLASI"}`} index={false} />

      <div className="page-title">{"Financije"}</div>

      <PaginationFinance
        carts={carts}
        isLoading={isLoading}
        handlePageChange={handlePageChange}
        handleTabChange={handleTabChange}
        handleDeleteCart={handleDeleteCart}
        activeTab={activeTab}
        responsiveProps={{
          xs: 24
        }}
        emptyCartsText={"Nema prethodnih transakcija za prikaz."}
      />
    </LeftMenu>
  );
}

export default requireUserLogin(
  requireUsernameChange(
    requireUserVerify(
      FinancePage
    )
  )
);


// WEBPACK FOOTER //
// ./src/containers/FinancePage/index.tsx